import recentScoresFetchReducer from "./recent-scores-fetch";
import { combineReducers } from "redux";

const reducers = combineReducers({ recentScoresFetchReducer });

export default reducers;
